require('../../modules/es.array.find');

module.exports = require('../../internals/entry-unbind')('Array', 'find');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/array/find.js
// module id = 168
// module chunks = 0